import { render, staticRenderFns } from "./SoftwareApplication.vue?vue&type=template&id=57cc7361&scoped=true"
import script from "./SoftwareApplication.vue?vue&type=script&lang=js"
export * from "./SoftwareApplication.vue?vue&type=script&lang=js"
import style0 from "./SoftwareApplication.vue?vue&type=style&index=0&id=57cc7361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc7361",
  null
  
)

export default component.exports